import { Component, Input, Output } from '@angular/core';
import { NgClass, NgForOf } from '@angular/common';
import { injectValueAccessor, ValueAccessorDirective } from '@panaya/ui/p-value-accessor';

@Component({
    selector: 'p-chip-radio-group',
    standalone: true,
    imports: [NgForOf, NgClass],
    templateUrl: './p-chip-radio-group.component.html',
    styleUrls: ['./p-chip-radio-group.component.scss'],
    hostDirectives: [ValueAccessorDirective]
})
export class PChipRadioGroupComponent {
    protected readonly valueAccessor = injectValueAccessor<PChipRadioId>();

    @Input() list: { id: PChipRadioId; label: string }[] = [];
    @Input() public set selectedId(value: PChipRadioId) {
        this.valueAccessor.setValue(value);
    }

    @Output() public readonly selectedIdChange = this.valueAccessor.viewValueChanged;

    public get selectedId(): PChipRadioId {
        return this.valueAccessor.value;
    }
}

export type PChipRadioId = string | number | undefined;

export type PChipRadioItem = { id: PChipRadioId; label: string };
